"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var UsrAdminEditor = /** @class */ (function (_super) {
    __extends(UsrAdminEditor, _super);
    function UsrAdminEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        return _this;
    }
    UsrAdminEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.recordKey > 0) {
            var _item = this.props.data.getById(this.props.recordKey);
            if (_item) {
                this.setState({
                    login: _item.login,
                    password: "",
                    name: _item.name,
                    surname: _item.surname,
                    email: _item.email,
                    phone: _item.phone,
                    skype: _item.skype,
                    is_locked: _item.is_locked,
                    permission_id: _item.permission_id,
                    permission_title: _item.permission_title,
                    permissions: this.props.data.DATA.permissions_avail,
                    is_multiaccess: _item.is_multiaccess,
                    tabKey: "main"
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование администратора"]);
                });
            }
        }
        else {
            this.setState({
                login: "",
                password: "",
                name: "",
                surname: "",
                email: "",
                phone: "",
                skype: "",
                is_locked: false,
                permission_id: 0,
                permission_title: "",
                permissions: this.props.data.DATA.permissions_avail,
                is_multiaccess: false,
                tabKey: "main"
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание администратора"]);
            });
        }
        this.doReSetRules();
    };
    UsrAdminEditor.prototype.doReSetRules = function () {
        this.setState({
            login_rules: { isError: false },
            password_rules: { isError: false },
            permission_rules: { isError: false }
        });
    };
    UsrAdminEditor.prototype.isDataValid = function () {
        if ((this.state.permission_id <= 0) || (this.state.permission_title.length === 0)) {
            this.setState({
                permission_rules: { isError: true, errorMessage: "Поле [права] не выбрано!" },
                tabKey: this.key_main
            });
            return;
        }
        if (!this.isOpen4Edit()) {
            if ((!this.state.login) || (this.state.login.length === 0)) {
                this.setState({
                    login_rules: { isError: true, errorMessage: "Поле [логин] не заполнено!" },
                    tabKey: this.key_main
                });
                return;
            }
            if ((!this.state.password) || (this.state.password.length === 0)) {
                this.setState({
                    password_rules: { isError: true, errorMessage: "Поле [пароль] не заполнено!" },
                    tabKey: this.key_main
                });
                return;
            }
        }
        return true;
    };
    UsrAdminEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddAdmin({
                login: this.state.login,
                password: this.state.password,
                name: this.state.name,
                surname: this.state.surname,
                email: this.state.email,
                phone: this.state.phone,
                skype: this.state.skype,
                is_locked: this.state.is_locked,
                permission_id: this.state.permission_id,
                permission_title: this.state.permission_title,
                is_multiaccess: this.state.is_multiaccess
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Администратор создан!");
            });
        }
    };
    UsrAdminEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditAdmin({
                key: this.props.recordKey,
                name: this.state.name,
                surname: this.state.surname,
                email: this.state.email,
                phone: this.state.phone,
                skype: this.state.skype,
                is_locked: this.state.is_locked,
                permission_id: this.state.permission_id,
                permission_title: this.state.permission_title,
                is_multiaccess: this.state.is_multiaccess
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Администратор изменен!");
            });
        }
    };
    UsrAdminEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    UsrAdminEditor.prototype.getFormTitle = function () {
        if (this.props.recordKey <= 0) {
            return "Новый администратор";
        }
        else {
            return "Изменить администратора";
        }
    };
    UsrAdminEditor.prototype.isOpen4Edit = function () {
        if (this.props.recordKey <= 0) {
            return false;
        }
        else {
            return true;
        }
    };
    UsrAdminEditor.prototype.doGenerateApiKey = function () {
        var _this = this;
        this.props.data.GenerateAdminPassword(function (password) {
            _this.setState({ password: password }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Пароль сгенерирован!");
            });
        });
    };
    UsrAdminEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Логин администратора:", placeholder: "Введите логин" }, value: this.state.login, onValueChanged: function (newVal) {
                    _this.setState({
                        login: newVal,
                        login_rules: { isError: false }
                    });
                }, disabled: this.isOpen4Edit(), required: !this.isOpen4Edit(), rules: this.state.login_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Пароль администратора:", placeholder: "Введите пароль", buttonHint: "Сгенерировать пароль" }, disabled: this.isOpen4Edit(), onButtonClick: this.doGenerateApiKey.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        password: newVal,
                        password_rules: { isError: false }
                    });
                }, value: this.state.password, buttonIcon: "key", required: !this.isOpen4Edit(), rules: this.state.password_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите привилегии :", placeholder: "Выберите привилегии" }, value: { key: this.state.permission_id, value: this.state.permission_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        permission_id: newVal.key,
                        permission_title: newVal.value,
                        permission_rules: { isError: false }
                    });
                }, items: this.state.permissions, required: true, rules: this.state.permission_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Администратор заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Мультидоступ", value: this.state.is_multiaccess, onChecked: function (checked) {
                    _this.setState({
                        is_multiaccess: checked
                    });
                } }),
            this.getDownButtons()));
    };
    UsrAdminEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Имя администратора:", placeholder: "Введите имя" }, value: this.state.name, onValueChanged: function (newVal) { _this.setState({ name: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Фамилия администратора:", placeholder: "Введите фамилию" }, value: this.state.surname, onValueChanged: function (newVal) { _this.setState({ surname: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "EMail администратора:", placeholder: "Введите email" }, value: this.state.email, onValueChanged: function (newVal) { _this.setState({ email: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Телефон администратора:", placeholder: "Введите телефон" }, value: this.state.phone, onValueChanged: function (newVal) { _this.setState({ phone: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Skype администратора:", placeholder: "Введите skype" }, value: this.state.skype, onValueChanged: function (newVal) { _this.setState({ skype: newVal }); } }),
            this.getDownButtons()));
    };
    UsrAdminEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.recordKey > 0, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    UsrAdminEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    UsrAdminEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        return null;
    };
    UsrAdminEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 520, activeTabKey: this.state.tabKey, tabs: [{ key: this.key_main, tab: "Основные" }, { key: this.key_additional, tab: "Дополнительные" }], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return UsrAdminEditor;
}(React.Component));
exports.default = UsrAdminEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_admins_list/ui/component/UsrAdminEditor.tsx
// module id = 1893
// module chunks = 0